import { useState } from "react";

const committeeData = [
  { sno: 1, type: "Anti-Ragging Committee", name: "J SIVA KUMAR", profession: "PRINCIPAL", mobile: "8096951451" },
  { sno: 2, type: "Anti-Ragging Committee", name: "G. LAKSHMI PRATAP", profession: "HOD/ECE", mobile: "7013845798" },
  { sno: 3, type: "Anti-Ragging Committee", name: "V NAGESWARA RAO", profession: "HOD/EE", mobile: "9848998222" },
  { sno: 4, type: "Anti-Ragging Committee", name: "D RAJESH", profession: "HOD/CCB", mobile: "9182732714" },
  { sno: 5, type: "Anti-Ragging Committee", name: "P SIRISHA", profession: "STUDENT", mobile: "8185000813" },
  { sno: 6, type: "Anti-Ragging Committee", name: "Sub-Inspector of Police, Vuyyuru Rural", profession: "POLICE", mobile: "9440627048" },
  { sno: 7, type: "Anti-Ragging Squad", name: "NALLURI NAGARAJU", profession: "LECTURER", mobile: "9866250844" },
  { sno: 8, type: "Anti-Ragging Squad", name: "R SAI TEJA", profession: "HOD/CIV", mobile: "8331809947" },
  { sno: 9, type: "Anti-Ragging Squad", name: "P SIDDI RAJU", profession: "HOD/MEC", mobile: "7330260798" },
  { sno: 10, type: "Anti-Ragging Squad", name: "A NAGENDRA", profession: "LECTURER", mobile: "9912255168" },
  { sno: 11, type: "Anti-Ragging Squad", name: "V NAGA LOKESH", profession: "STUDENT", mobile: "9912624278" },
  { sno: 12, type: "Anti-Ragging Squad", name: "V SRESTA", profession: "STUDENT", mobile: "9908852697" },
];

const AntiRaggingCommittee = () => {
  const [filter, setFilter] = useState("All");

  const filteredData =
    filter === "All"
      ? committeeData
      : committeeData.filter((m) => m.type === filter);

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", background: "#f5f6fa", minHeight: "100vh", padding: "24px" }}>
      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: "28px" }}>
        
        <h1 style={{ fontSize: "26px", fontWeight: "700", color: "#1a1a2e", margin: 0, letterSpacing: "0.5px" }}>
          Anti Ragging Committee
        </h1>
        {/* <p style={{ color: "#666", fontSize: "13px", marginTop: "6px" }}>Date: 19-12-2025</p> */}
      </div>

      {/* Notice Box */}
      <div style={{
        background: "#fff",
        border: "1px solid #e0e0e0",
        borderLeft: "4px solid #c8a400",
        borderRadius: "8px",
        padding: "20px 24px",
        marginBottom: "24px",
        maxWidth: "960px",
        margin: "0 auto 24px auto",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)"
      }}>
        <h2 style={{ fontSize: "15px", fontWeight: "700", textDecoration: "underline", marginBottom: "10px", color: "#1a1a2e" }}>
          NOTICE
        </h2>
        <p style={{ fontSize: "13.5px", color: "#444", lineHeight: "1.7", margin: "0 0 10px 0" }}>
          The Anti-Ragging Committee has been formed as per clauses 6.3 (c), (d) and (e) of the{" "}
          <em>UGC Regulations on curbing the menace of Ragging in Higher Educational Institutions, 2009</em>{" "}
          in this institute. Contact numbers of the Principal and members are given below and the same have
          been prominently displayed. In case of any objectionable behavior of a senior student, the above
          officials can be contacted. Ragging in any form is strictly prohibited and the students involved
          would be punished according to the legal provisions.
        </p>
        <p style={{ fontSize: "13.5px", color: "#444", lineHeight: "1.7", margin: 0 }}>
          Institute has also constituted Anti-Ragging Committee &amp; Anti-Ragging Squad.
        </p>
      </div>

      {/* Filter Buttons */}
      <div style={{ maxWidth: "960px", margin: "0 auto 16px auto", display: "flex", gap: "10px", flexWrap: "wrap" }}>
        {["All", "Anti-Ragging Committee", "Anti-Ragging Squad"].map((tab) => (
          <button
            key={tab}
            onClick={() => setFilter(tab)}
            style={{
              padding: "6px 16px",
              borderRadius: "20px",
              border: filter === tab ? "none" : "1px solid #ccc",
              background: filter === tab ? "#c8a400" : "#fff",
              color: filter === tab ? "#fff" : "#555",
              fontWeight: filter === tab ? "600" : "400",
              fontSize: "13px",
              cursor: "pointer",
              transition: "all 0.2s"
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Table */}
      <div style={{ maxWidth: "960px", margin: "0 auto", background: "#fff", borderRadius: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f0f0f0" }}>
              {["S.No", "Committee Type", "Name of Member", "Profession", "Mobile Number"].map((h) => (
                <th key={h} style={{
                  padding: "12px 16px",
                  textAlign: "left",
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#333",
                  borderBottom: "2px solid #ddd"
                }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.map((row, idx) => (
              <tr
                key={row.sno}
                style={{
                  borderBottom: "1px solid #f0f0f0",
                  background: idx % 2 === 0 ? "#fff" : "#fafafa",
                  transition: "background 0.15s"
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#fffbea"}
                onMouseLeave={e => e.currentTarget.style.background = idx % 2 === 0 ? "#fff" : "#fafafa"}
              >
                <td style={{ padding: "11px 16px", fontSize: "13px", color: "#555" }}>{row.sno}</td>
                <td style={{ padding: "11px 16px", fontSize: "13px", color: "#555" }}>
                  <span style={{
                    padding: "3px 10px",
                    borderRadius: "12px",
                    fontSize: "12px",
                    fontWeight: "500",
                    background: row.type === "Anti-Ragging Committee" ? "#e8f4fd" : "#fef9e7",
                    color: row.type === "Anti-Ragging Committee" ? "#1a73c8" : "#a87c00",
                  }}>
                    {row.type}
                  </span>
                </td>
                <td style={{ padding: "11px 16px", fontSize: "13px", fontWeight: "600", color: "#222" }}>{row.name}</td>
                <td style={{ padding: "11px 16px", fontSize: "13px", color: "#555" }}>{row.profession}</td>
                <td style={{ padding: "11px 16px", fontSize: "13px", color: "#555" }}>{row.mobile}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer note */}
      <div style={{ maxWidth: "960px", margin: "18px auto 0 auto", textAlign: "center" }}>
        <p style={{ fontSize: "12px", color: "#aaa" }}>
          Established as per AICTE Notification No. 37-3/Legal/AICTE/2009, dated 01.07.2009 &amp; UGC Regulations.
        </p>
      </div>
    </div>
  );
};

export default AntiRaggingCommittee;
